export { default } from './StudioLogoSvg';
